import { createFileRoute } from '@tanstack/react-router'
import { JobSources } from '@/features/job-detail/sources'

export const Route = createFileRoute(
  '/_authenticated/jobs/$jobId/sources/'
)({
  component: JobSources,
})
